import type { FC, ReactNode } from 'react'
import type { LayoutProps } from '@/types'

import { Footer } from '@/components/generals/footer'
import { Navbar } from '@/components/generals/navbar'
import { Stage } from '@/components/generals/stage'

export const Layout: FC<LayoutProps> = ({ children, footer = true }): ReactNode => {
    return (
        <div className='riffle-stage riffle-page relative flex min-h-screen w-full flex-col'>
            <Stage />

            <Navbar />

            <main className='relative z-10 flex-1'>
                {children}
            </main>

            {footer ? <Footer /> : null}
        </div>
    )
}
